import React from "react";
import { Row } from "@intechprev/componentes-web";

import { PlanoService } from "../../services";
import { MasterPage } from "..";
import { PlanoVinculadoEntidade } from "../../entidades";
import { PlanoItem } from "./PlanoItem";
import { NumFuncionalidade } from "../MasterPage";
import { reCAPTCHA } from "../../helpers";

interface Props { }

interface State {
  listaPlanos: Array<PlanoVinculadoEntidade>;
  cdPlano: string;
}

export class Planos extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("planos");

  private page = React.createRef<MasterPage>();

  constructor(props: Props) {
    super(props)

    this.state = {
      listaPlanos: [],
      cdPlano: ""
    }
  }

  componentDidMount = async () => {
    try {
      await this.page.current.alternarLoading();

      var listaPlanos = await PlanoService.Buscar();

      await this.setState({
        listaPlanos
      });

      await this.page.current.alternarLoading();
    }
    catch (err) {
      console.log(err);
    }
  }

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.EXTRATO} {...this.props} ref={this.page}>
        <Row>
          {this.state.listaPlanos.map((plano: any, index: number) => {
            return (
              <PlanoItem key={index} plano={plano} />
            )
          })}
        </Row>
      </MasterPage>
    );
  }
}